import PersonalReviewer from "@/views/pages/PersonalReviewer.vue";
import TotalOrderLogsPopup from "@/views/pages/SelfServiceWithoutTable/TotalOrderLogsPopup.vue";
import Cookies from "js-cookie";
import CookieKeys from "@/model/constants/cookieKeys";
import RadialProgressBar from "vue-radial-progress";
import SwitchAccount from "@/views/pages/SelfServiceWithoutTable/SwitchAccount.vue";
import CartOrder from "@/views/pages/SelfServiceWithoutTable/CartOrder.vue";
import ProductListPage from "@/views/pages/SelfServiceWithoutTable/ProductListPage.vue";
import ProductVariantSelection from "@/views/pages/SelfServiceWithoutTable/ProductVariantSelection.vue";
import CartEntry from "@/views/pages/SelfServiceWithoutTable/CartEntry.vue";
import selfServiceStore from "@/store/selfService/selfService.js";
import {
  navigationQuestionForRedirect,
  getPosSettings,
} from "@/api/AppSettings";
import { getCategoryAndProduct } from "@/api/ProductCategory";
import { fetchUserWithCodes } from "@/api/User";
import {
  fetchLastBillId,
  changePassword,
  updateEmail,
  mobileOrderCount,
} from "@/api/SelfService";
import { getPaymentMethodList } from "@/api/PaymentMethod";
import companyInfo from "@/model/constants/companyInfo";
import NewExpenseAddForSelfService from "@/views/pages/SelfServiceWithoutTable/NewExpenseAddForSelfService.vue";
import TopOfTheDayScreen from "@/views/pages/SelfServiceWithoutTable/TopOfTheDayScreen.vue";
import { isGranted } from "@/utils/auth";
import signalRService from "@/SignalRService";
import DayInterimScreen from "@/views/pages/SelfServiceWithoutTable/DayInterimScreen.vue";
import {
  getIsDayOpening,
  getIsDayInterim,
  getBranchOpenClose,
  getRealTime,
  createDayOpen,
  createDayClose
} from "@/api/DayOpen.js";
import DayCloseScreen from "@/views/pages/SelfServiceWithoutTable/DayCloseScreen.vue";
import { getDayReportEnable } from "@/api/DayReportSetting";
import SafeCashEntry from "@/views/pages/SelfServiceWithoutTable/SafeCashEntry.vue";
import { GetAllDiscountReason } from "@/api/DiscountReason.js";
import { getPrinterSetting } from "@/api/PrinterSetting";

export default {
  components: {
    ProductListPage,
    ProductVariantSelection,
    CartEntry,
    CartOrder,
    SwitchAccount,
    RadialProgressBar,
    TotalOrderLogsPopup,
    PersonalReviewer,
    NewExpenseAddForSelfService,
    TopOfTheDayScreen,
    DayInterimScreen,
    DayCloseScreen,
    SafeCashEntry,
  },
  data() {
    return {
      isKiosk: true,
      isSafeOperations: false,
      isUserOperations: false,
      isPersonalReviewerActive: false,
      profileActionPage: 0,
      newUserCodeObj: {},
      newUserEmailObj: {},
      isRequestActive: false,
      isAuth: false,
      isPosEnabled: false,
      posData: null,
      isActiveChangePassword: false,
      toggleProfileActions: false,
      screenLock: false,
      cartEntry: null,
      productList: null,
      time: null,
      logo: companyInfo.logo,
      openClose: {},
      timerId: null,
      isTimerEffect: false,
      dayReportIsEnable: false,
      isEmailUpdate: false,
      newOrder: false,
      orderQuantity: 0,
      sidebarWidth: "sidebar-reduced",
      audioPlayer: null,
      audioIsPlaying: false,
      lastPlayTime: 0,
      ignoreInitialSound: true,
      currentTime: "",
      moment: require('moment-timezone'),
      inactivityTimer: null,
      remainingTime: 180,
      isTimeoutPopupActive: false,
      popupCountdown: 10,
      popupTimer: null,
    };
  },
  computed: {
    notSwitchQuery() {
      return this.$route.query.notSwitch === "true";
    },
    isAddLoss() {
      return isGranted("discount_loss_create");
    },
    isOrderListActive() {
      return this.$refs.cartOrder && this.$refs.cartOrder.isOrderListActive;
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    isActiveTotalOrderLogs: {
      get() {
        return this.$refs.totalOrderLogsPopup.isActive;
      },
      set(val) {
        this.$refs.totalOrderLogsPopup.isActive = val;
      },
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    isProductVariantSelectionOpen: {
      get() {
        return this.$refs.variantSelection
          ? this.$refs.variantSelection.isProductVariantSelectionOpen
          : null;
      },
      set(val) {
        this.$refs.variantSelection.isProductVariantSelectionOpen = val;
      },
    },
    preSelectedProduct() {
      return this.$store.getters["selfservice/getPreSelectedProduct"];
    },
    selectedProduct() {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    isTopDay: {
      get() {
        return true;
      },
      set(val) {
        // this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    activePersonal: {
      get() {
        let personal = this.$store.getters["selfservice/getActivePersonal"];
        // Eğer activePersonal null ise ve switch gizliyse, current user'ı kullan
        if (!personal && this.notSwitchQuery) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          if (userInfo) {
            this.$store.dispatch("selfservice/setActivePersonal", userInfo);
            return userInfo;
          }
        }
        return personal;
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    isAdminActivePersonal() {
      return this.activePersonal.role.some((x) => x.name == "admin");
    },
    currentDate() {
      let date = this.moment().locale("tr");
      date = date.tz("Europe/Istanbul").format("ddd Do MMM")
      return date;
    },
    currentCartEntriesLength() {
      const currentCart = this.$store.getters["selfservice/getCurrentCart"];
      return currentCart && currentCart.cartEntries ? currentCart.cartEntries.length : 0;
    },
  },
  watch: {
    profileActionPage(newVal, oldVal) {
      if (newVal < 0 || newVal > 1) this.profileActionPage = oldVal;
    },
    isActiveChangePassword(val) {
      this.newUserCodeObj = {};
    },
    preSelectedProduct: function (val) {
      if (val != null) {
        this.isProductVariantSelectionOpen = true;
      } else {
        this.isProductVariantSelectionOpen = false;
      }
    },
    lossMode(val) {
      this.isReset = true;
    },
    currentCartEntriesLength(newVal, oldVal) {
      if (this.isKiosk) {
        if (newVal > 0 && oldVal === 0) {
          this.startInactivityTimer();
        } else if (newVal === 0) {
          this.stopInactivityTimer();
          this.stopPopupTimer();
          this.isTimeoutPopupActive = false;
          localStorage.removeItem('kiosk_timer_expiry');
        }
      }
    },
    '$store.state.selfservice.carts': {
      deep: true,
      handler(val) {
        if (this.isKiosk && val) {
          localStorage.setItem('kiosk_carts', JSON.stringify(val));
        }
      }
    },
  },
  methods: {
    getCurrentTime() {
      this.currentTime = this.moment().locale("tr");
      this.currentTime = this.currentTime.tz('Europe/Istanbul').format("H:mm:ss");
      setTimeout(this.getCurrentTime, 1000);
    },
    // Get current order quantity
    async getOrderQuantity() {
      try {
        const response = await mobileOrderCount();
        this.orderQuantity = response;
        return response;
      } catch (error) {
        console.error("Error fetching order quantity:", error);
        return 0;
      }
    },

    // Check if there are new orders
    hasNewOrder() {
      return this.newOrder;
    },

    // Reset new order flag
    resetNewOrder() {
      this.newOrder = false;
    },

    // Refresh the order quantity
    async refreshOrderQuantity() {
      await this.getOrderQuantity();
      return this.orderQuantity;
    },

    // ProductListPage'i güncelle
    updateProductListPage() {
      if (this.$refs.productListPage) {
        console.log(
          "ProductListPage sipariş sayısı güncelleniyor:",
          this.orderQuantity
        );
        this.$refs.productListPage.orderQuantity = this.orderQuantity;

        if (this.newOrder) {
          this.$refs.productListPage.newOrder = true;
          console.log("ProductListPage'de yeni sipariş işaretlendi");
        }
      } else {
        console.warn("ProductListPage henüz erişilebilir değil");
      }
    },

    openCustomerScreen() {
      const primaryScreenWidth = window.screen.width;
      const features = `fullscreen=yes,menubar=no,toolbar=no,location=no,status=no,left=${primaryScreenWidth},top=${window.screen.height},width=0,height=0`;
      window.open(
        "/pages/customer-screen",
        "Lütfen ekrana tıklayınız...",
        features
      );
    },

    // Ses çalma işlemini düzenli hale getir
    playOrderNotificationSound(forcePlay = false) {
      // Debug
      console.log("playOrderNotificationSound çağrıldı", {
        ignoreInitialSound: this.ignoreInitialSound,
        forcePlay,
        audioIsPlaying: this.audioIsPlaying,
        lastPlayTime: this.lastPlayTime,
        timeDiff: Date.now() - this.lastPlayTime,
      });

      // Başlangıçta sesi engelle (uygulamanın açılışında gereksiz çalmaması için)
      if (this.ignoreInitialSound && !forcePlay) {
        console.log("Başlangıç sesi engellendi");
        this.ignoreInitialSound = false;
        return;
      }

      // Sesler arasında en az 5 saniye olsun (üst üste çalmayı önler)
      const MIN_TIME_BETWEEN_SOUNDS = 5000; // 5 saniye
      const now = Date.now();
      if (now - this.lastPlayTime < MIN_TIME_BETWEEN_SOUNDS && !forcePlay) {
        console.log(
          `Son çalmadan bu yana ${now - this.lastPlayTime
          }ms geçti - çok kısa, çalmıyor`
        );
        return;
      }

      if (this.audioPlayer) {
        // Çalıyor durumda ise önce durdur
        if (this.audioIsPlaying) {
          console.log("Ses zaten çalıyor, durdurulup sıfırlanıyor");
          this.audioPlayer.pause();
          this.audioPlayer.currentTime = 0;
        }

        // Ses dosyasını çal
        this.audioIsPlaying = true;
        this.lastPlayTime = now;
        console.log("Ses çalınmaya başlıyor");

        this.audioPlayer
          .play()
          .then(() => {
            console.log("Notification sound played successfully");
          })
          .catch((err) => {
            console.error("Error playing sound:", err);
            this.audioIsPlaying = false;
          });

        // Ses bittiğinde bayrağı sıfırla
        this.audioPlayer.onended = () => {
          console.log("Ses çalma tamamlandı");
          this.audioIsPlaying = false;
        };
      } else {
        console.error("Audio player not initialized");
      }
    },

    getOpenClose: async function () {
      this.openClose = (await getBranchOpenClose()).data;
    },
    dayCloseClick() {
      // Gün sonu raporu pasif ise işlem yapma
      if (!this.dayReportIsEnable) {
        // Pasif ise notification göster ve devam et
        this.$vs.notify({
          color: 'warning',
          title: 'Bilgi',
          text: 'Bu şube için gün sonu raporu pasiftir.'
        });
        return;
      }

      this.$refs.dayclosescreenref.isOldClose = false;
      this.$refs.dayclosescreenref.isActive = true;
    },
    async checkAndStartSilentDay() {
      try {
        const isDayOpening = await getIsDayOpening();
        const activeUser = this.$store.state.AppActiveUser || JSON.parse(localStorage.getItem("userInfo"));
        const userData = {
          safeCash: 0,
          userId: activeUser.id,
          userName: activeUser.name,
          nextDayCash: 0,
          xReportForCard: 0
        };

        if (isDayOpening.data == 0) {
          console.log("[SilentDay] Başlatılmamış gün tespit edildi (Masasız), açılıyor...");
          await createDayOpen(userData);
          await this.getOpenClose();
        } else if (isDayOpening.data == 1) {
          console.log("[SilentDay] Kapatılmamış gün tespit edildi (Masasız), kapatılıp yenisi açılıyor...");
          await createDayClose(userData);
          await createDayOpen(userData);
          await this.getOpenClose();
        }
      } catch (error) {
        console.error("[SilentDay] Hata:", error);
      }
    },
    checkClosingTime: async function () {
      await this.getOpenClose();
      var remoteDate = await getRealTime();
      const currentTime = new Date(remoteDate.data);
      const targetTime = new Date();
      const currentTimeMinutes =
        currentTime.getHours() * 60 + currentTime.getMinutes();
      const targetTimeMinutes =
        parseInt(this.openClose.closeTime.split(":")[0]) * 60 +
        parseInt(this.openClose.closeTime.split(":")[1]);
      let timeDifference = targetTimeMinutes - currentTimeMinutes;
      let closeTime = new Date(this.openClose.openDate);
      let openTime = new Date(this.openClose.openDate);
      closeTime.setHours(
        parseInt(this.openClose.closeTime.split(":")[0]),
        parseInt(this.openClose.closeTime.split(":")[1]),
        0
      );
      openTime.setHours(
        parseInt(this.openClose.openTime.split(":")[0]),
        parseInt(this.openClose.openTime.split(":")[1]),
        0
      );
      console.log(currentTime);
      console.log(closeTime);
      console.log(openTime);
      if (openTime.getTime() > closeTime.getTime()) {
        closeTime.setDate(currentTime.getDate() + 1);
      }
      timeDifference = closeTime.getTime() - currentTime.getTime();
      if (timeDifference <= 600000) {
        this.isTimerEffect = true;
      } else {
        this.isTimerEffect = false;
      }
    },
    emitCloseReportSelfService(result) {
      if (result) {
        this.$refs.topofthedayscreenref.isActive = true;
      }
    },
    emitDisableSelfService(result) {
      if (result) {
        // document.getElementById('araRaporButton').disabled = true;
      }
    },
    saveExpense(payload) {
      this.$store.dispatch("expense/addExpense", payload).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error,
        });
      });
    },
    addNewExpense() {
      this.$refs.newExpenseAdd.isActive = true;
    },
    toggleDropdown() {
      this.isSafeOperations = !this.isSafeOperations;
    },
    toggleUserOperations() {
      this.isUserOperations = !this.isUserOperations;
    },
    getAvatar(image) {
      if (image == "") return this.logo;
      else return this.$baseUrl + "/" + image;
    },
    resetProfileSelection() {
      this.toggleProfileActions = false;
      this.profileActionPage = 0;
    },
    toggleEmailUpdate() {
      this.isEmailUpdate = !this.isEmailUpdate;
    },
    updateEmailMethod: async function () {
      console.log(this.newUserEmailObj.email);
      try {
        await updateEmail({
          email: this.newUserEmailObj.email,
        }).then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Email güncellendi",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Email güncellenemedi",
            });
          }
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: error.response.data.Errors[0].Message,
        });
      }
    },
    changePassword: async function () {
      let check = await this.$validator.validateAll();
      if (!check) return;
      if (this.activePersonal.userCode != this.newUserCodeObj.oldCode) {
        this.$fire({
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Eski Kod Aktif Kullanıcının Kodu ile Eşleşmiyor !",
        });
      } else {
        changePassword({
          userId: this.activePersonal.id,
          userCode: this.newUserCodeObj.newCode,
        })
          .then((res) => {
            if (res && res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: "Kod Başarıyla Değiştirildi !",
                text: "Yeni Kod Kullanıma Hazır.",
              });
              this.isActiveChangePassword = false;
              this.$store.dispatch(
                "selfservice/setActivePersonalUserCode",
                this.newUserCodeObj.newCode
              );
            }
          })
          .catch((x) => {
            this.$fire({
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Kod Değiştirme Başarısız !",
            });
          });
      }
    },
    doExit() {
      this.$router.push("/pages/login");
    },
    screenLockToggle() {
      if (!this.isOrderListActive && !this.notSwitchQuery) {
        this.activePersonal = null;
      }
    },
    onSelectProduct(val) {
      this.preSelectedProduct = val;
      this.isProductVariantSelectionOpen = true;
    },
    productSelectionCompleted: function (val) {
      this.cartEntry = val;
      this.isProductVariantSelectionOpen = false;
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
    },
    closeProductSelection: function () {
      this.isProductVariantSelectionOpen = false;
    },
    fetchCategories: async function () {
      try {
        this.productList = await getCategoryAndProduct();
      } catch (e) {
        this.productList = null;
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchUsers: async function () {
      try {
        let response = await fetchUserWithCodes();
        var currentUser = response.find((x) => x.id == this.$currentUser.id);
        this.newUserEmailObj.email = currentUser.email;
        this.$store.dispatch("selfservice/setPersonList", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setPersonList", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    fetchLastBillId: async function () {
      try {
        let response = await fetchLastBillId();
        this.$store.dispatch("selfservice/setLastBillId", response + 1);
      } catch (e) {
        this.$store.dispatch("selfservice/setLastBillId", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    getPaymentMethodList: async function () {
      try {
        let response = await getPaymentMethodList();
        
        if (response && response.length > 0) {
          const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
          const creditIdx = response.findIndex(x => x.id == creditId || (x.name && x.name.toLowerCase().includes('kredi')));
          
          if (creditIdx !== -1) {
            response[creditIdx].selected = true;
          } else {
            response[0].selected = true;
          }
        }
        
        this.$store.dispatch("selfservice/setPaymentMethods", response);
      } catch (e) {
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    inactivityTime() {
      // window.onload = this.resetTimer;
      // document.onmousemove = this.resetTimer;
      // document.onkeypress = this.resetTimer;
      // document.onclick = this.resetTimer;
    },
    resetTimer() {
      // if (this.activePersonal !== null) {
      //   clearTimeout(this.time);
      //   this.time = setTimeout(this.screenLockToggle, this.$afkTimeOut);
      // }
    },
    getNavigationQuestionForSale: async function () {
      try {
        let response = await navigationQuestionForRedirect();
        this.$store.dispatch("selfservice/setNavigationQuestion", response);
      } catch (e) {
        this.$store.dispatch("selfservice/setNavigationQuestion", null);
        this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: e.message,
        });
      }
    },
    connectPos: async function (loadScreen) {
      this.isRequestActive = true;
      this.isLoading = loadScreen;
      await fetch(process.env.VUE_APP_POS_API + "pair", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((res) => {
          this.isRequestActive = false;
          this.isLoading = false;
          if (res.hasError == false || res.statusCode == 200) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihazına Bağlanıldı.",
              text: "",
            });
          } else if (res.message.includes("Cihaz Bağlantısı yapıldı")) {
            this.$vs.notify({
              color: "success",
              title: "Pos Cihaz Bağlantısı Yapıldı!",
              text: res.message,
            });
          } else {
            this.$fire({
              title: "Hata !",
              text: "Pos Cihaz Bağlantısı Yapılamadı !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Pos Cihaz Bağlantısı Yapılamadı !",
              text: res.message,
            });
          }
        })
        .catch((x) => {
          this.isRequestActive = false;
          this.isLoading = false;
          this.$fire({
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Pos Cihaz Bağlantısı Yapılamadı !",
          });
        });
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo) {
        this.$router.push("/");
      }
      let branchId = await userInfo.branch.id;
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posData = axiosResponse.data;
    },
    getDiscountReasons: async function () {
      try {
        let response = await GetAllDiscountReason();
        if (response && response.status == 200) {
          this.$store.dispatch("selfservice/setDiscountReasons", response.data);
        } else {
          this.$fire({
            title: "Hata : " + response.status,
            text: "İndirim Sebepleri Yüklenemedi !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + response.status,
            text: "İndirim Sebepleri Yüklenemedi !",
          });
        }
      } catch (error) {
        this.$fire({
          title: "Hata",
          text: "İndirim Sebepleri Yüklenemedi!",
          type: "error",
        });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "İndirim Sebepleri Yüklenirken Bağlantı Hatası!",
        });
      }
    },
    // Hareketsizlik Zamanlayıcısı Metotları
    startInactivityTimer() {
      this.stopInactivityTimer();
      
      const savedExpiry = localStorage.getItem('kiosk_timer_expiry');
      if (savedExpiry) {
        const remaining = Math.floor((parseInt(savedExpiry) - Date.now()) / 1000);
        if (remaining > 0) {
          this.remainingTime = remaining;
        } else {
          this.remainingTime = 180;
          localStorage.setItem('kiosk_timer_expiry', Date.now() + 180000);
        }
      } else {
        this.remainingTime = 180; // 3 dakika
        localStorage.setItem('kiosk_timer_expiry', Date.now() + 180000);
      }

      this.inactivityTimer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.handleTimeout();
        }
      }, 1000);
    },
    stopInactivityTimer() {
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer);
        this.inactivityTimer = null;
      }
    },
    resetInactivityTimer() {
      this.remainingTime = 180;
      localStorage.setItem('kiosk_timer_expiry', Date.now() + 180000);
      this.isTimeoutPopupActive = false;
      this.stopPopupTimer();
      if (!this.inactivityTimer) {
        this.startInactivityTimer();
      }
    },
    handleTimeout() {
      this.stopInactivityTimer();
      this.isTimeoutPopupActive = true;
      this.popupCountdown = 10;
      this.startPopupCountdown();
    },
    startPopupCountdown() {
      this.stopPopupTimer();
      this.popupTimer = setInterval(() => {
        if (this.popupCountdown > 0) {
          this.popupCountdown--;
        } else {
          this.cancelAction();
        }
      }, 1000);
    },
    stopPopupTimer() {
      if (this.popupTimer) {
        clearInterval(this.popupTimer);
        this.popupTimer = null;
      }
    },
    confirmContinuedAction() {
      this.resetInactivityTimer();
    },
    cancelAction() {
      this.isTimeoutPopupActive = false;
      this.stopPopupTimer();
      this.stopInactivityTimer();
      
      // Ödeme ekranı açıksa kapat
      try {
        if (this.$refs.cartOrder && this.$refs.cartOrder.$refs.orderList) {
          const orderList = this.$refs.cartOrder.$refs.orderList;
          if (orderList.isActive) {
            orderList.isActive = false;
            orderList.isPaymentStarted = false;
            orderList.isTransaction = false;
            orderList.selectedPaymentGroup = [];
            orderList.paymentGroups = [];
            orderList.orderPayments = [];
            orderList.discounts = [];
            orderList.note = "";
            orderList.customerName = "";
            orderList.cloneCurrentCart = { cartEntries: [] };
          }
        }
        // Trigger global reset for kiosk state
        this.isReset = true;
      } catch (e) {
        console.warn('[KioskOrder] cancelAction - orderList ref error:', e);
      }

      this.$store.dispatch("selfservice/clearAllCarts");
      localStorage.removeItem('kiosk_carts');
      localStorage.removeItem('kiosk_timer_expiry');
      this.$vs.notify({
        color: "warning",
        title: "Bilgi",
        text: "Hareketsizlik nedeniyle sepetiniz temizlendi.",
      });
    },
    formatRemainingTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
  },
  created() {
    this.getDiscountReasons();
    this.productList = null;

    this.checkPosDevice().then(() => {
      if (this.isPosEnabled) this.connectPos(false);
    });

    this.fetchCategories();
    this.fetchUsers();
    this.fetchLastBillId();
    this.getPaymentMethodList();
    this.getNavigationQuestionForSale();
    
    getPrinterSetting().then(response => {
      this.$store.dispatch("selfservice/setPrinterSettings", response.data);
    });

    let checkAuth = Cookies.get(CookieKeys.AUTH_KEY);
    checkAuth ? (this.isAuth = true) : this.$router.push("/pages/login");

    if (this.isKiosk) {
      this.isScreenLock = false;
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (userInfo) {
        this.$store.dispatch("selfservice/setActivePersonal", userInfo);
      }

      // Sepeti localStorage'dan yükle
      const savedCarts = localStorage.getItem('kiosk_carts');
      if (savedCarts) {
        try {
          const parsed = JSON.parse(savedCarts);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.$store.dispatch("selfservice/setToCart", parsed);
          }
        } catch (e) {
          console.error("Error loading kiosk carts", e);
        }
      }
    } else if (this.notSwitchQuery) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (userInfo) {
        this.$store.dispatch("selfservice/setActivePersonal", userInfo);
        this.isScreenLock = false;
      }
    } else {
      this.isScreenLock = false;
    }

    Promise.all([
      getDayReportEnable(),
      this.getOpenClose()
    ]).then(([dayReportResponse]) => {
      this.dayReportIsEnable = dayReportResponse.data;
      
      if (this.dayReportIsEnable) {
        if (this.isKiosk) {
            this.checkAndStartSilentDay();
        } else {
            getIsDayOpening().then(isDayOpening => {
              if (isDayOpening.data == 0) {
                this.$refs.topofthedayscreenref.isActive = true;
              }
              if (isDayOpening.data == 1) {
                this.$refs.dayclosescreenref.isOldClose = true;
                this.$refs.dayclosescreenref.lastOpenDate = this.openClose.lastOpenDate;
                this.$refs.dayclosescreenref.isActive = true;
              }
            });
        }

        getIsDayInterim();
        this.timerId = setInterval(this.checkClosingTime, 300000);
      } else {
        this.checkAndStartSilentDay();
      }
    });

    this.inactivityTime();

    const branchId = this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null;
    signalRService.initConnection(branchId).then(() => {
      signalRService.on("SendOrder", (message) => {
        var audio = new Audio(process.env.VUE_APP_ORDER_AUDIO);
        audio.play();
        this.newOrder = true;
        
        if (this.$refs.productListPage) {
          this.$refs.productListPage.newOrder = true;
          this.refreshOrderQuantity().then(() => {
            if (this.$refs.productListPage) {
              this.$refs.productListPage.orderQuantity = this.orderQuantity;
            }
          });
        }
      });

      signalRService.on("OrderQuantityInBranch", (quantity) => {
        this.orderQuantity = quantity;
        if (this.$refs.productListPage) {
          this.$refs.productListPage.orderQuantity = quantity;
        }
      });
    });

    mobileOrderCount().then(quantity => {
      this.orderQuantity = quantity;
      if (this.orderQuantity > 0) {
        this.newOrder = true;
        this.$nextTick(() => {
          this.updateProductListPage();
        });
      }
    });
  },

  // Sayfa oluşturulduktan sonra, DOM erişimi için
  mounted() {
    this.getCurrentTime();
    // Sayfa ilk açıldığında layout'un tam oturması için resize tetikle
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);

    setTimeout(() => {
      this.updateProductListPage();
    }, 200);
  },

  beforeCreate: function () {
    if (!selfServiceStore.isRegistered) {
      this.$store.registerModule("selfservice", selfServiceStore);
      selfServiceStore.isRegistered = true;
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }

    // Remove event listeners when component is destroyed
    try {
      console.log("SignalR olay dinleyicileri kaldırılıyor");
      signalRService.off("SendOrder");
      signalRService.off("OrderQuantityInBranch");
      console.log("SignalR olay dinleyicileri başarıyla kaldırıldı");
    } catch (error) {
      console.error("SignalR olay dinleyicileri kaldırılırken hata:", error);
    }
  },
  provide() {
    return {
      refreshOrderQuantity: this.refreshOrderQuantity,
      getOrderQuantity: this.getOrderQuantity,
      hasNewOrder: this.hasNewOrder,
      resetNewOrder: this.resetNewOrder,
    };
  },
};
